export const charitabletrust = [
    { title: "3) CHARITABLE TRUST", header: true },
    { title: "(i) Registration Under Local Act" },
    { title: "(ii) Societies Registration Act" },
    { title: "Registration Under Income Tax Act" },
    { title: `"Exemption Certificate under section 80G of Income Tax Act"` },
    { title: "Filing Objection Memo/other Replies" },
    { title: "Filing of Change Report" },
    { title: "Filing of Annual Budget" },
    { title: `"Attending before Charity Commissioner including for Attending Objections"` },
    { title: "(i) F.C.R.A. Registration" },
    { title: "(ii) F.C.R.A. Certification" },
  ];

  export const companyTasks = [
    { title: "4) COMPANY LAW AND LLP WORK", header: true },
    { title: "Filing Application for Name Approval" },
    { title: "Incorporation of a Private Limited Company/LLP" },
    { title: "Incorporation of a Public Limited Company" },
    { title: "Advisory or consultation in drafting MOA, AOA" },
    { title: "(i) Company’s/LLP ROC Work, Preparation of Minutes, Statutory Register & Other Secretarial Work" },
    { title: "(ii) Certification (Per Certificate)" },
    { title: "Filing Annual Return Etc." },
    { title: "Filing Other Forms Like: F-32, 18, 2 etc." },
    { title: "Increase in Authorised Capital Filing of F-5, F-23, preparation of Revised Memorandum of Association/Article of Association/LLP Agreement" },
    { title: "DPIN/DIN per Application" },
    { title: "Company Law Consultancy including Petition drafting" },
    { title: "Company Law representation including LLP before RD and NCLT" },
    { title: "ROC Representation" },
  ];

  // AuditData.js
export const auditData = [
    { title: "5) AUDIT AND OTHER ASSIGNMENTS", header: true },
    { title: "Rate per day would depend on the complexity of the work and the number of days spent by each person", subHeader: true },
    { title: "(i) Principal" },
    { title: "(ii) Qualified Assistants" },
    { title: "(iii) Semi Qualified Assistants" },
    { title: "(iv) Other Assistants" },
    { title: "Subject to minimum indicative Fees as under:", subHeader: true },
    { title: "(i) Tax Audit" },
    { title: "(ii) Company Audit" },
    { title: "(a) Small Pvt. Ltd. Co. (Turnover up to ` 2 crore)" },
    { title: "(b) Medium Size Pvt. Ltd. Co./ Public Ltd. Co." },
    { title: "(c) Large Size Pvt. Ltd. Co./ Public" },
    { title: "(iv) Review of TDS Compliance" },
    { title: "(v) Transfer Pricing Audit" },
  ];

  // assignmentData.js
export const assignmentData = [
  {
    header: true,
    title: "6) INVESTIGATION, MANAGEMENT SERVICES OR SPECIAL ASSIGNMENTS",
  },
  {
    subHeader: true,
    title: "Rate per day would depend on the complexity of the work and the number of days spent by each person",
  },
  {
    title: "(a) Principal",
  },
  {
    title: "(b) Qualified Assistant",
  },
  {
    title: "(c) Semi Qualified Assistant",
  },
];

// certificationData.js
export const certificationData = [
  {
    header: true,
    title: "7) CERTIFICATION WORK",
  },
  {
    title: "(a) Issuing Certificates under the Income Tax Act i.e. U/s 80IA/80IB/10 A/10B & other Certificates",
  },
  {
    title: "(b) Other Certificates For LIC/ Passport/Credit Card/Etc.",
  },
  {
    title: "(c) Other Attestation (True Copy)",
  },
  {
    title: "(d) Net worth Certificate for person going abroad",
  },
];

export const reraData = [
  {
    header: true,
    title: "8) RERA",
  },
  {
    title: "(a) Audit of Accounts",
  },
  {
    title: "(b) Appearance Before Appellate Tribunal of Regulatory Authority or Adjudicating Authority",
  },
  {
    title: "(c) Advisory & Consultation",
  },
  {
    title: "(d) Certification for withdrawal of amount",
  },
];

// consultationData.js
export const consultationData = [
  {
    header: true,
    title: "9) CONSULTATION & ARBITRATION",
  },
  {
    subHeader: true,
    title: "Rate per hour would depend on the complexity of the work and the number of hours spent by each person",
  },
  {
    title: "(a) Principal",
  },
  {
    title: "(b) Qualified Assistant",
  },
  {
    title: "(c) Semi Qualified Assistant",
  },
];

export const nbfcData = [
  {
    header: true,
    title: "10) NBFC/RBI MATTERS",
  },
  {
    title: "(a) NBFC Registration with RBI",
  },
  {
    title: "(b) Other Returns",
  },
];

export const gstData = [
  {
    header: true,
    title: "11) GST",
  },
  {
    title: "(a) Registration",
  },
  {
    title: "(b) Registration with Consultation",
  },
  {
    title: "(c) Tax Advisory & Consultation i.e. about value, taxability, classification, etc.",
  },
  {
    title: "(d) Challan/Returns",
  },
  {
    title: "(e) Adjudication/Show Cause notice reply",
  },
  {
    title: "(f) Filing of Appeal / Appeals Drafting",
  },
  {
    title: "(g) Furnish details of inward/outward supply",
  },
  {
    title: "(h) Misc services i.e. refund, cancellation/revocation registration, maintain electronic cash ledger etc.",
  },
  {
    title: "(i) Audit of accounts and reconciliation Statement",
  },
  {
    title: "(j) Any Certification Work",
  },
];

export const femaData = [
  {
    header: true,
    title: "12) FEMA MATTERS",
  },
  {
    title: "(a) Filing Declaration with RBI in relation to transaction by NRIs/ OCBs",
  },
  {
    title: "(b) Obtaining Prior Permissions from RBI for Transaction with NRIs/ OCBs",
  },
  {
    title: "(c) Technical collaboration: Advising, obtaining RBI permission, drafting and preparing technical collaboration agreement and incidental matters",
  },
  {
    title: "(d) Foreign collaboration: Advising, obtaining RBI permission, drafting and preparing technical collaboration agreement and incidental matters (incl. Shareholders Agreement)",
  },
  {
    title: "(e) Advising on Non Resident Taxation Matters including Double Tax Avoidance Agreements including FEMA",
  },
];

export const projectFinancingData = [
  {
    header: true,
    title: "13) PROJECT FINANCING",
  },
  {
    title: "(a) Preparation of CMA data",
  },
  {
    title: "(b) Services relating to Financial sector",
  },
];

export const accountancyServicesData = [
  {
    header: true,
    title: "14) ACCOUNTANCY SERVICES (New Heading)",
  },
  {
    title: "Book Keeping and the preparation of financial statements",
  },
  {
    title: "Other Services",
  },
];

export const otherServicesData = [
  {
    header: true,
    title: "15) Other Services not listed above",
  },
];

export const complianceData = [
  {
  "CompaniesAct2013Compliances": [
    "Annual General Meeting (AGM)",
    "Annual Return (Form MGT-7)",
    "Financial Statements (Form AOC-4)",
    "Change in Director or KMP (Form DIR-12)",
    "Change in Registered Office (Form INC-22)",
    "Increase in Authorized Share Capital (Form SH-7)",
    "Allotment of Shares (Form PAS-3)",
    "Significant Beneficial Ownership (Form BEN-2)"
  ],
  "IncomeTaxAct1961Compliances": [
    "Filing of Income Tax Return",
    "Tax Audit (Form 3CA/3CB and 3CD)",
    "Payment of Advance Tax",
    "Tax Deducted at Source (TDS)"
  ],
  "GSTAct2017Compliances": [
    "GST Registration",
    "Filing of GST Returns",
    "Payment of GST"
  ],
  "EmployeeRelatedCompliances": [
    "Provident Fund (PF)",
    "Employees' State Insurance (ESI)",
    "Professional Tax"
  ],
  "OtherRegulatoryCompliances": [
    "Director KYC (Form DIR-3 KYC)",
    "Maintenance of Statutory Registers",
    "Compliance under Foreign Exchange Management Act (FEMA)",
    "CSR (Corporate Social Responsibility)",
    "Secretarial Audit"
  ],
  "MiscellaneousCompliances": [
    "Board Meetings",
    "Maintenance of Minutes",
    "Issuance of Share Certificates",
    "Compliance Certificate (Form MGT-8)"
  ],
  "AdditionalCompliances": [
    "Appointment of Auditor (Form ADT-1)",
    "Auditor’s Report (Form ADT-4)",
    "Filing of Board Resolution (Form MGT-14)",
    "Filing of Special Resolution (Form MGT-14)",
    "Form DPT-3 for Deposits",
    "Filing of MSME Form I (for outstanding payments to MSME vendors)",
    "Declaration of Commencement of Business (Form INC-20A)",
    "Filing of Charge Creation/Modification/Satisfaction (Form CHG-1, CHG-4)",
    "Filing of DIR-8 (Intimation by Director)",
    "Filing of Form MR-1 for Appointment of Managerial Personnel",
    "Maintenance of Register of Contracts (Form MBP-4)",
    "Register of Charges (Form CHG-7)",
    "Filing of Form BEN-1 for Significant Beneficial Owner",
    "Filing of Form BEN-4 (Notice to SBOs)",
    "Form NDH-1 (Nidhi Company Compliance)",
    "Form NDH-2 (Application for Extension of Time)",
    "Form NDH-3 (Half-yearly Return)",
    "Appointment of Cost Auditor (Form CRA-2)",
    "Cost Audit Report (Form CRA-4)",
    "Form FC-1 (Foreign Company Registration)",
    "Form FC-3 (Annual Accounts of Foreign Company)"
  ]
}
]






  